import { colors } from "../../Styles";

export function Phone({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <ellipse cx="-3217.78" cy="-1897.37" rx="330.89" ry="202.21"/>
      <ellipse cx="-3266.8" cy="-1459.24" rx="453.45" ry="186.89"/>
      <rect x="1053.2" y="-1704.34" width="2101.79" height="245.11" rx="-607.07" ry="-607.07"/>
      <path d="M100.3,103.73s22.79-15.33,26.52-18.23,6.63-8.7,3.73-19.06c-2.9-10.36-8.35-26.52-14.53-36.47-6.19-9.95-62.54,5.8-63.37,9.12s-14.09,83.29,36.47,147.94c50.56,64.64,99.87,77.08,104.84,75.42,4.97-1.66,38.95-40.61,38.12-48.9-.83-8.29-29.42-34.39-39.37-39.37-9.95-4.97-33.57,19.48-33.57,19.48,0,0-58.01-41.02-58.84-89.92Z"/>
    </svg>
  );
}
